// generated from 392_482 samples

import { z } from "zod";
import { common } from "../common";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { colorSchema } from "../shared/colorSchema";
import { clickActionSchema } from "../shared/clickActionSchema";
import { orBehaviorTriggerGetSchema } from "../trigger/orBehaviorTriggerGetSchema";
import { triggerGetSchema } from "../trigger/triggerGetSchema";
import { grapesJsDataSchema } from "../grapesJs/grapesJsDataSchema";
import { surveyDefinitionGetSchema } from "./surveyDefinitionGetSchema";

const triggerMessageGetColorSchema = z.union([z.string(), z.int()]);

export const triggerMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("trigger"),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 52_295 (17.35%), false 249_202 (82.65%)
  app_group_has_any_html_full_messages: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 8_033 (2.66%), false 293_464 (97.34%)
  app_group_has_any_web_html_messages: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 287_538 (95.37%)
  // "" when a drag-and-drop message is saved without an associated template:
  // DragAndDropComposerWrapper dispatches `associatedTemplateId ?? ""`, and the server stores and
  // returns the String field verbatim (SlideUpMessageParameters#associated_template_id).
  associated_template_id: z
    .union([common.objectId, z.literal("")])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 3_989 (1.32%)
  // avg: 4190965465.85, min: 0, max: 4294967295
  background_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 3_989 (1.32%)
  // avg: 4278628233.14, min: 0, max: 4294967295
  body_text_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  buttons: z
    .array(
      z.object({
        // null: 98_131 (99.07%)
        android_bap: z.array(z.string()).nullable().optional(),
        // null: 99_041 (99.99%)
        android_china_bap: z.array(z.string()).nullable().optional(),
        // null: 34_936 (35.27%)
        android_china_click_action: clickActionSchema.nullable().optional(),
        // null: 97_053 (97.98%)
        android_china_uri: z.string().nullable().optional(),
        // null: 35_334 (35.67%)
        // true 2_526 (3.96%), false 61_191 (96.04%)
        android_china_use_webview: z.boolean().nullable().optional(),
        // null: 5_408 (5.46%)
        android_click_action: clickActionSchema.nullable().optional(),
        // null: 43_561 (43.98%)
        android_uri: z.string().nullable().optional(),
        // null: 5_818 (5.87%)
        // true 11_687 (12.54%), false 81_546 (87.46%)
        android_use_webview: z.boolean().nullable().optional(),
        // null: 128 (0.13%)
        // format hex: 98_923 (100.00%)
        background_color: triggerMessageGetColorSchema.nullable().optional(),
        // null: 1_855 (1.87%)
        // format hex: 97_196 (100.00%)
        border_color: triggerMessageGetColorSchema.nullable().optional(),
        // null: 98_103 (99.04%)
        ios_bap: z.array(z.string()).nullable().optional(),
        // null: 5_404 (5.46%)
        ios_click_action: clickActionSchema.nullable().optional(),
        // null: 44_774 (45.20%)
        ios_uri: z.string().nullable().optional(),
        // null: 5_818 (5.87%)
        // true 11_652 (12.50%), false 81_581 (87.50%)
        ios_use_webview: z.boolean().nullable().optional(),
        kepler_bap: z.null().optional(),
        // null: 55_230 (55.76%)
        kepler_click_action: clickActionSchema.nullable().optional(),
        // null: 99_045 (99.99%)
        kepler_uri: z.string().nullable().optional(),
        // null: 55_230 (55.76%)
        kepler_use_webview: z.literal(false).nullable().optional(),
        // null: 99_033 (99.98%)
        kindle_bap: z.array(z.string()).nullable().optional(),
        // null: 5_420 (5.47%)
        kindle_click_action: clickActionSchema.nullable().optional(),
        // null: 96_172 (97.09%)
        kindle_uri: z.string().nullable().optional(),
        // null: 5_818 (5.87%)
        // true 3_205 (3.44%), false 90_028 (96.56%)
        kindle_use_webview: z.boolean().nullable().optional(),
        // null: 98_938 (99.89%)
        roku_click_action: clickActionSchema.nullable().optional(),
        // null: 99_025 (99.97%)
        roku_uri: z.string().nullable().optional(),
        text: z.string().nullable().optional(),
        // null: 128 (0.13%)
        // format hex: 98_923 (100.00%)
        text_color: triggerMessageGetColorSchema.nullable().optional(),
        // null: 98_713 (99.66%)
        web_bap: z.array(z.string()).nullable().optional(),
        // null: 60_445 (61.02%)
        web_click_action: clickActionSchema.nullable().optional(),
        // null: 81_101 (81.88%)
        web_uri: z.string().nullable().optional(),
        // null: 99_037 (99.99%)
        windows8_click_action: clickActionSchema.nullable().optional(),
        // null: 99_037 (99.99%)
        windows8_uri: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  // undefined: 199_989 (50.95%), defined 192_493 (49.05%)
  // null: 1 (0.00%)
  canvas_trigger_schedule: z
    .object({
      // null: 157_037 (81.58%)
      // true 7_874 (22.21%), false 27_581 (77.79%)
      availability_expiration_in_user_local_time: z.boolean().nullable().optional(),
      // null: 156_464 (81.28%)
      availability_expiration_without_zone: common.dateTimeLocal.nullable().optional(),
      // null: 39_162 (20.34%)
      // avg: 322335.50, min: 0, max: 2678400
      availability_in_seconds: z.int().min(0).nullable().optional(),
      // null: 1_395 (0.72%)
      trigger_event: z.union([orBehaviorTriggerGetSchema, triggerGetSchema]).nullable().optional(),
      personalized_expiration_duration_variable: z.string().nullable().optional(),
      personalized_expiration_duration_variable_type: z.string().nullable().optional(),
      personalized_expiration_duration_variable_unit: z.string().nullable().optional(),
      /** Explicit availability type. Single source of truth for IAM expiration behavior. */
      availability_type: z
        .enum([
          "available_for_a_fixed_duration_in_seconds",
          "available_until_expiration_date",
          "available_until_personalized_expiration",
        ])
        .nullable()
        .optional(),
    })
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 4_003 (1.33%)
  // avg: 4256839951.92, min: 0, max: 4294967295
  close_button_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 25_409 (8.43%)
  composer_mode: z
    .enum([
      "TRADITIONAL", // 199_477 (72.25%)
      "DRAG_AND_DROP", // 76_611 (27.75%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 285_593 (94.72%)
  content_hash: z
    .object({
      body: z.string(),
      // undefined: 613 (3.85%), defined 15_291 (96.15%)
      choices: z
        .array(
          z.object({
            attributeKey: z.string(),
            attributeValue: z.string(),
            // format uuid: 37_038 (78.44%)
            id: z.string(),
            text: z.string(),
          })
        )
        .nullable()
        .optional(),
      // undefined: 623 (3.92%), defined 15_281 (96.08%)
      confirmationBody: z.string().nullable().optional(),
      // undefined: 623 (3.92%), defined 15_281 (96.08%)
      confirmationButton: z
        .object({
          onClickBehavior: z.object({
            action: z.enum([
              "CLOSE", // 14_892 (97.45%)
              "REDIRECT_TO_URL", // 227 (1.49%)
              "DEEP_LINK", // 162 (1.06%)
            ]),
            uri: z.string(),
            // true 15_230 (99.67%), false 51 (0.33%)
            useWebview: z.boolean(),
          }),
          text: z.string(),
        })
        .nullable()
        .optional(),
      // undefined: 623 (3.92%), defined 15_281 (96.08%)
      confirmationHeader: z.string().nullable().optional(),
      // undefined: 15_796 (99.32%), defined 108 (0.68%)
      // null: 1 (0.93%)
      explanatoryLink: z
        .object({
          // true 61 (57.01%), false 46 (42.99%)
          openInNewWindow: z.boolean(),
          text: z.string(),
          url: z.string(),
        })
        .nullable()
        .optional(),
      header: z.string(),
      // undefined: 615 (3.87%), defined 15_289 (96.13%)
      helperText: z.string().nullable().optional(),
      // undefined: 15_574 (97.93%), defined 330 (2.07%)
      // null: 102 (30.91%)
      imageUrl: z.string().nullable().optional(),
      // undefined: 15_291 (96.15%), defined 613 (3.85%)
      input: z
        .object({
          placeholder: z.string(),
        })
        .nullable()
        .optional(),
      // undefined: 613 (3.85%), defined 15_291 (96.15%)
      // true 9_487 (62.04%), false 5_804 (37.96%)
      isLoggingCustomAttribute: z.boolean().nullable().optional(),
      // undefined: 613 (3.85%), defined 15_291 (96.15%)
      // true 1_600 (10.46%), false 13_691 (89.54%)
      isMultipleChoice: z.boolean().nullable().optional(),
      // undefined: 13_007 (81.78%), defined 2_897 (18.22%)
      startOnConfirmation: z.literal(false).nullable().optional(),
      // undefined: 613 (3.85%), defined 15_291 (96.15%)
      submitBehavior: z
        .enum([
          "DISPLAY_CONFIRMATION_PAGE", // 13_577 (88.79%)
          "CLOSE_MESSAGE_IMMEDIATELY", // 1_714 (11.21%)
        ])
        .nullable()
        .optional(),
      submitButtonText: z.string(),
      // undefined: 15_291 (96.15%), defined 613 (3.85%)
      textAlignment: z
        .enum([
          "CENTER", // 607 (99.02%)
          "START", // 5 (0.82%)
          "END", // 1 (0.16%)
        ])
        .nullable()
        .optional(),
      // undefined: 15_291 (96.15%), defined 613 (3.85%)
      theme: z
        .object({
          backgroundColor: colorSchema,
          bodyTextColor: colorSchema,
          buttons: z.tuple([
            z.object({
              backgroundColor: colorSchema,
              // null: 12 (1.96%)
              borderColor: colorSchema.nullable(),
              textColor: colorSchema,
            }),
          ]),
          closeButtonColor: colorSchema,
          frameColor: colorSchema,
          headerTextColor: colorSchema,
        })
        .nullable()
        .optional(),
      // undefined: 621 (3.90%), defined 15_283 (96.10%)
      themeColor: colorSchema.nullable().optional(),
    })
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_237 (99.91%)
  custom_css: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 286_206 (94.93%)
  deleted_choices: z
    .array(
      z.object({
        attributeKey: z.string(),
        attributeValue: z.string(),
        deleted: z.literal(true),
        id: common.uuid,
        text: z.string(),
      })
    )
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 226_620 (75.16%)
  dnd_display_type: z
    .enum([
      "MODAL", // 68_873 (91.98%)
      "FULLSCREEN", // 3_902 (5.21%)
      "modal", // 2_090 (2.79%)
      "fullscreen", // 12 (0.02%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 300_884 (99.80%)
  email_capture_placeholder: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_390 (99.96%)
  explanatory_link: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 61 (0.02%), false 301_436 (99.98%)
  explanatory_link_in_new_window: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_390 (99.96%)
  explanatory_link_text: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 4_479 (1.49%)
  // avg: 3111464393.30, min: 0, max: 4294967295
  frame_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 221_766 (73.55%)
  grapes_js_data: grapesJsDataSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 1_562 (0.52%), false 299_935 (99.48%)
  has_push_primer: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 3_594 (1.19%)
  header_text: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 4_017 (1.33%)
  // avg: 4279336480.37, min: 0, max: 4294967295
  header_text_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 222_406 (73.77%)
  html: z
    .record(
      z.string(),
      z.object({
        index: z.int().min(0),
        value: z.string(),
      })
    )
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  iam_canvas_trigger_delay_in_seconds: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  iam_canvas_trigger_delay_option: z
    .enum([
      "immediately", // 301_495 (100.00%)
      "after", // 2 (0.00%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 297_024 (98.52%)
  // format hex: 4_473 (100.00%)
  icon: z.string().length(4).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 4_017 (1.33%)
  // avg: 4263505488.48, min: 0, max: 4294967295
  icon_background_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 4_017 (1.33%)
  // avg: 4277418183.87, min: 0, max: 4294967295
  icon_color: z.int().min(0).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  image_alt_text: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 195_930 (64.99%)
  // integer: 41_744 (39.54%)
  // avg: 1.27, min: 0.28663629460895973, max: 60.666666666666664
  image_aspect_ratio: z.number().nonnegative().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 165_153 (54.78%)
  image_style: z
    .enum([
      "TOP", // 71_961 (52.78%)
      "GRAPHIC", // 64_383 (47.22%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 177_543 (58.89%)
  image_url: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 10_189 (3.38%), false 291_308 (96.62%)
  is_custom_image_url: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_482 (100.00%)
  language: z.string().nullable().optional(),
  // null: 48 (0.01%)
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 294_656 (97.73%)
  minimum_iam_generation: z
    .union([z.literal(1), z.literal(2), z.literal(3)])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 352 (0.12%), false 301_145 (99.88%)
  only_ipads: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // true 637 (0.21%), false 300_860 (99.79%)
  only_iphones: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 287_606 (95.39%)
  orientation: z
    .enum([
      "PORTRAIT", // 13_236 (95.28%)
      "LANDSCAPE", // 655 (4.72%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_186 (99.90%)
  slideup_android_bap: z.array(z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 15_072 (5.00%)
  slideup_android_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 227_387 (75.42%)
  slideup_android_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 16_160 (5.36%)
  // true 8_846 (3.10%), false 276_491 (96.90%)
  slideup_android_use_webview: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  slideup_campaign_id: z.null().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  slideup_card_id: z.null().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 1_286 (0.43%)
  // avg: 5925.37, min: -100000, max: 6200000
  slideup_duration: z.int().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 283_847 (94.15%)
  slideup_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_179 (99.89%)
  slideup_ios_bap: z.array(z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 15_072 (5.00%)
  slideup_ios_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 230_806 (76.55%)
  slideup_ios_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 16_160 (5.36%)
  // true 8_686 (3.04%), false 276_651 (96.96%)
  slideup_ios_use_webview: z.boolean().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  slideup_kepler_bap: z.array(z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 167_002 (55.39%)
  slideup_kepler_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  slideup_kepler_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 167_002 (55.39%)
  slideup_kepler_use_webview: z.literal(false).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_493 (100.00%)
  slideup_kindle_bap: z.array(z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 15_184 (5.04%)
  slideup_kindle_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 296_639 (98.39%)
  slideup_kindle_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 16_160 (5.36%)
  // true 5_304 (1.86%), false 280_033 (98.14%)
  slideup_kindle_use_webview: z.boolean().nullable().optional(),
  // undefined: 90_994 (23.18%), defined 301_488 (76.82%)
  slideup_message: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 230 (0.08%)
  slideup_message_close: z
    .enum([
      "SWIPE", // 272_508 (90.45%)
      "AUTO_DISMISS", // 28_759 (9.55%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 573 (0.19%)
  slideup_open_target: z
    .enum([
      "NONE", // 296_030 (98.37%)
      "BLANK", // 4_894 (1.63%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 299_603 (99.37%)
  slideup_roku_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_382 (99.96%)
  slideup_roku_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 132 (0.04%)
  slideup_slide_from: z
    .enum([
      "BOTTOM", // 275_821 (91.52%)
      "TOP", // 25_544 (8.48%)
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_436 (99.98%)
  slideup_web_bap: z.array(z.string()).nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 171_595 (56.91%)
  slideup_web_click_action: clickActionSchema.nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 282_765 (93.79%)
  slideup_web_uri: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 176_053 (58.39%)
  targeted_platforms: z
    .tuple([
      // null: 1 (0.00%)
      z
        .enum([
          "NATIVE", // 113_253 (90.28%)
          "WEB", // 11_953 (9.53%)
          "ROKU", // 237 (0.19%)
        ])
        .nullable(),
    ])
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 35_688 (11.84%)
  text_alignment: z
    .enum([
      "CENTER", // 263_036 (98.96%)
      "START", // 2_735 (1.03%)
      "END", // 38 (0.01%)
    ])
    .nullable()
    .optional(),
  // undefined: 379_311 (96.64%), defined 13_171 (3.36%)
  themes: z
    .object({
      dark: z.object({
        // avg: 3936558235.01, min: 0, max: 4294967295
        background_color: z.int().min(0).nullable().optional(),
        // null: 1 (0.01%)
        // avg: 4292521660.16, min: 0, max: 4294967295
        body_text_color: z.int().min(0).nullable().optional(),
        buttons: z.array(
          z.object({
            // format hex: 8_245 (100.00%)
            background_color: triggerMessageGetColorSchema.nullable().optional(),
            // null: 2 (0.02%)
            // format hex: 8_243 (100.00%)
            border_color: triggerMessageGetColorSchema.nullable().optional(),
            // null: 2 (0.02%)
            // format hex: 8_243 (100.00%)
            text_color: triggerMessageGetColorSchema.nullable().optional(),
          })
        ),
        // null: 1 (0.01%)
        // avg: 4250378118.77, min: 0, max: 4294967295
        close_button_color: z.int().min(0).nullable().optional(),
        // null: 1 (0.01%)
        // avg: 2996437467.03, min: 0, max: 4294967295
        frame_color: z.int().min(0).nullable().optional(),
        // null: 1 (0.01%)
        // avg: 4293608041.35, min: 0, max: 4294967295
        header_text_color: z.int().min(0).nullable().optional(),
        // null: 1 (0.01%)
        // avg: 4276983762.59, min: 0, max: 4294967295
        icon_background_color: z.int().min(0).nullable().optional(),
        // null: 1 (0.01%)
        // avg: 4279393601.27, min: 0, max: 4294967295
        icon_color: z.int().min(0).nullable().optional(),
      }),
    })
    .nullable()
    .optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 1_692 (0.56%)
  type: z
    .enum([
      "HTML", // 129_424 (43.17%)
      "MODAL", // 103_056 (34.37%)
      "SLIDEUP", // 35_081 (11.70%)
      "FULL", // 13_944 (4.65%)
      "SURVEY", // 13_628 (4.55%)
      "HTML_FULL", // 3_557 (1.19%)
      "EMAIL_CAPTURE", // 612 (0.20%)
      "MODAL_STYLED", // 260 (0.09%)
      "WEB_HTML", // 242 (0.08%)
      "WEB_EMAIL_CAPTURE", // 1 (0.00%)
    ])
    .nullable()
    .optional(),
  // Required for messages with zip_url
  zip_id: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 298_678 (99.06%)
  zipped_assets_url: z.string().nullable().optional(),
  // Alias of zipped_assets_url
  zip_url: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 301_468 (99.99%)
  zipped_assets_self_hosted_url: z.string().nullable().optional(),
  // Alias of zipped_assets_self_hosted_url
  zip_self_hosted_url: z.string().nullable().optional(),
  // undefined: 90_985 (23.18%), defined 301_497 (76.82%)
  // null: 298_074 (98.86%)
  // avg: 793909.29, min: 188, max: 5036354
  zipped_assets_url_file_size: z.int().nonnegative().nullable().optional(),
  survey_definition: surveyDefinitionGetSchema.nullable().optional(),
});
